<app-notification></app-notification>
<app-loader></app-loader>
<router-outlet></router-outlet>
